import { css } from '@emotion/react'
import custom from 'shared/styles/custom.styles'

const styles = () => {
    return {
        buttons: css`
            display: grid;
            grid-template-columns: 1fr 1fr 1fr 1fr;
            grid-gap: 12px;
            padding-top: 20px;
        `,
        button: css`
            ${custom.button};
        `,
    }
}

export default styles
